import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAdvantagesItemClick } from './tracking';
import { Advantages } from '../../components/Advantages';
import { FullscreenPopup, Content } from '../../components/FullscreenPopup';
import { getAdvantages } from '../../selectors/newbuilding';
import { AsideContentPopupHeader } from '../AsideContentPopupHeader';

const ADVANTAGE_POPUP_FAVORITE_EVENT_ACTIONS = {
  add: 'add_from_jk_features',
  remove: 'remove_from_jk_features',
};

export function AdvantagesContainer() {
  const [isOpened, setOpenedState] = React.useState(false);
  const [advantageIndex, setAdvantageIndex] = React.useState(0);

  const advantages = useSelector(getAdvantages);

  const onItemClick = React.useCallback(
    (i: number) => {
      setAdvantageIndex(i);
      setOpenedState(true);

      const item = advantages[i];
      if (item) {
        trackAdvantagesItemClick(item.advantageType);
      }
    },
    [setOpenedState, setAdvantageIndex, advantages],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!advantages || advantages.length === 0) {
    return null;
  }

  const advantage = advantages[advantageIndex];

  return (
    <>
      <Advantages advantages={advantages} onItemClick={onItemClick} />
      <FullscreenPopup
        isOpened={isOpened}
        header={
          <AsideContentPopupHeader
            onClose={onClose}
            favoriteActions={ADVANTAGE_POPUP_FAVORITE_EVENT_ACTIONS}
            callAction="Open_jk_features"
            dynamicCallTrackingTitle="Advantages"
          />
        }
        onClose={onClose}
        content={isOpened ? <Content {...advantage} /> : null}
      />
    </>
  );
}
